import axios from 'axios';
import jwtDecode, { JwtPayload } from 'jwt-decode';
import { v4 as uuidv4 } from 'uuid';
import * as GlobalConfig from '../config/GlobalConfig';
import { getSessionStorageValue, getStoreJwt, setSessionStorage } from '../utils/utils';

export const sessionId = () => {
  let sessionId = getSessionStorageValue("MgpSessionId");
  if(!sessionId) {
    sessionId = uuidv4();
    setSessionStorage("MgpSessionId", sessionId);
  }

  return sessionId;
}

// export const authApi = (jwt?: string, headers?: Map<string, string>) => {
//   const mgpHeaders = {common: {}} as any;
//   mgpHeaders.common['X-Channel-Id'] = 'WEB';
//   mgpHeaders.common['Accept'] = 'application/json';
//   mgpHeaders.common['X-Request-Id'] = sessionId();
//    mgpHeaders.common['Access-Control-Allow-Origin'] = '*';
//   if(headers && headers.size > 0) {
//     headers.forEach((v,k) => {
//       mgpHeaders[k] = v;
//     });
    
//   }
//   let axiosInstance = axios.create({
//     baseURL:  GlobalConfig.apiAuthBaseUrl,
//     headers: mgpHeaders
//   });

//   if (jwt) {
//       axiosInstance.interceptors.request.use(function (config) {
//       config!.headers!.Authorization =  jwt ? `Bearer ${jwt}` : '';
//       return config;
//   });
//   }

//   return axiosInstance;
// };

export const authApi = (headers?: Map<string, string>) => {
  const mgpHeaders = { common: {} } as any;
  mgpHeaders.common['X-Channel-Id'] = 'WEB';
  mgpHeaders.common['Accept'] = 'application/json';
  mgpHeaders.common['X-Request-Id'] = sessionId();
  mgpHeaders.common['Access-Control-Allow-Origin'] = '*';
  if (headers && headers.size > 0) {
    headers.forEach((v, k) => {
      mgpHeaders[k] = v;
    });

  }
  let axiosInstance = axios.create({
    baseURL: GlobalConfig.apiAuthBaseUrl,
    headers: mgpHeaders
  });

  return axiosInstance;
};

export const collectiveAffiliationApi = (jwt: string, acceptType?: string, cacheId?: string) => {
  const acceptTypeHeader = acceptType ? acceptType: 'application/json';
  const cache = cacheId ?? "";
  return baseBusinessApi(process.env.REACT_APP_API_COLLECTIVE_AFFILIATION_BASE_URL!, jwt, acceptTypeHeader, cache);
};

export const toolApi = (jwt: string, acceptType?: string) => {
const acceptTypeHeader = acceptType ? acceptType: 'application/json';
return baseBusinessApi(process.env.REACT_APP_API_TOOL_BASE_URL!, jwt, acceptTypeHeader);
};

export const tarificationApi = (jwt: string, acceptType?: string) => {
  const acceptTypeHeader = acceptType ? acceptType: 'application/json';
  return baseBusinessApi(process.env.REACT_APP_API_TARIFICATION_BASE_URL!, jwt, acceptTypeHeader);
};

export const collectiveAffiliationApiWithoutToken = (acceptType?: string) => {
  const acceptTypeHeader = acceptType ?? 'application/json';
    return baseBusinessApi(process.env.REACT_APP_API_COLLECTIVE_AFFILIATION_BASE_URL!, '', acceptTypeHeader);
};

export const collectiveAffiliationApiWithoutTokenV2 = (acceptType?: string) => {
  const acceptTypeHeader = acceptType ?? 'application/json';
    return baseBusinessApi(process.env.REACT_APP_API_COLLECTIVE_AFFILIATION_BASE_URL_V2!, '', acceptTypeHeader);
};


export const baseBusinessApi = (baseUrl:  string,jwt: string, acceptType?: string, cacheId?: string) => {
  
  const mgpHeaders = {common: {}} as any;
  mgpHeaders.common['X-Channel-Id'] = 'WEB';
  mgpHeaders.common['Accept'] = acceptType ? acceptType: 'application/json';
  mgpHeaders.common['X-Request-Id'] = sessionId();
  if (cacheId) {
    mgpHeaders.common['X-Cache-Id'] = cacheId;
  }
  let axiosInstance = axios.create({
    baseURL:  baseUrl,
    headers: mgpHeaders
  });
  
  axiosInstance.interceptors.request.use(function (config) {
    config!.headers!.Authorization =  jwt ? `Bearer ${jwt}` : '';
    return config;
  });
  axiosInstance.interceptors.response.use(
    (response) => {
      return response;
    },
    (error) => {
      switch (error.response.status) {
        case 401:
        case 403:
          break;
      }
      return Promise.reject(error);
    },
  );

  return axiosInstance;
};

export const notificationApi = (jwt: string, acceptType?: string) => {
  
  const mgpHeaders = {common: {}} as any;
  mgpHeaders.common['X-Channel-Id'] = 'WEB';
  mgpHeaders.common['Accept'] = acceptType ? acceptType: 'application/json';
  mgpHeaders.common['X-Request-Id'] = sessionId();
  let axiosInstance = axios.create({
    baseURL:  GlobalConfig.apiNotificationBaseUrl,
    headers: mgpHeaders
  });
  
  axiosInstance.interceptors.request.use(function (config) {
    config!.headers!.Authorization =  jwt ? `Bearer ${jwt}` : '';
    return config;
  });
  axiosInstance.interceptors.response.use(
    (response) => {
      return response;
    },
    (error) => {
      switch (error.response.status) {
        case 401:
        case 403:
          break;
      }
      return Promise.reject(error);
    },
  );

  return axiosInstance;
};

export function isTokenValid(token: string) {
  try {
    const decoded_jwt: JwtPayload = jwtDecode(token);
    const current_time = Date.now().valueOf() / 1000;
    
    return  decoded_jwt.exp && decoded_jwt.exp > current_time  + 1000;
  } catch (error) {
    console.log(error);
    return false;
  }
}

export function decodeToken(token: string, includeExpiredToken?: boolean) {
  let decoded_jwt: JwtPayload;
  try {
    decoded_jwt = jwtDecode(token);
    if(includeExpiredToken) {
      return decoded_jwt;
    }
    const current_time = Date.now().valueOf() / 1000;
    if(decoded_jwt.exp && decoded_jwt.exp > current_time  + 1000) {
      return decoded_jwt;
    }
  } catch (error) {
    console.log(error);
  }

  return null;
}
